import { render, staticRenderFns } from "./EditLinks.vue?vue&type=template&id=5a1099f4&scoped=true"
import script from "./EditLinks.vue?vue&type=script&lang=js"
export * from "./EditLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1099f4",
  null
  
)

export default component.exports